import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  Cell,
} from "recharts";
import { VIZ } from "../../css/brandTokens";

// Igual que BarrasCategoria, pero con la rampa ordinal (`<Cell fill={VIZ.rampa[i]} />`) — SOLO para
// escalas con orden natural (RF-15: tier 0..4). Aplicarla a una categoría nominal es RF-30 roto.
const BarrasRampa = ({ datos, height = 220, nombreKey = "Nombre", valorKey = "Total", anchoEtiquetas = 90 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <BarChart data={datos} layout="vertical" margin={{ top: 4, right: 48, left: 4, bottom: 4 }}>
      <CartesianGrid stroke={VIZ.grid} horizontal={false} />
      <XAxis type="number" hide />
      <YAxis
        type="category"
        dataKey={nombreKey}
        width={anchoEtiquetas}
        stroke={VIZ.axis}
        tickLine={false}
        tick={{ fill: VIZ.ink2, fontSize: 12 }}
      />
      <Tooltip
        cursor={{ fill: "rgba(17,17,19,.05)" }}
        contentStyle={{ borderRadius: 8, borderColor: VIZ.grid, fontSize: 13 }}
      />
      <Bar dataKey={valorKey} radius={[0, 4, 4, 0]} maxBarSize={20}>
        {datos.map((entrada, indice) => (
          <Cell key={entrada[nombreKey]} fill={VIZ.rampa[indice % VIZ.rampa.length]} />
        ))}
        <LabelList dataKey={valorKey} position="right" style={{ fill: VIZ.ink, fontSize: 12, fontWeight: 600 }} />
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);

export default BarrasRampa;
